export default class coordinateSlide {
    constructor(effect) {
        this.status = {
            slide: {
                current: 0,
                prevCurrent: 0,
                motion: false,
                slideTime: 0,
                max: 2
            },
        }

        this.effect = effect
        this.$slider
        this.$sliderList
        this.$sliderListSide
        this.$sliderNum
    }
    init(scroll, mouse) {
        this.$slider = document.getElementById('p-coordinate-slide')
        this.$sliderList = this.$slider.querySelectorAll(
            '.slide-left .swiper-slide'
        )
        this.$sliderListSide = this.$slider.querySelectorAll(
            '.slide-right .swiper-slide'
        )
        this.$sliderNum = this.$slider.querySelector(
            '.slide-current-num .current'
        )

        this.$slider.querySelector(".slider-btn .arrow-right").addEventListener('click', e => {
            this.status.slide.current =
                this.$sliderList['length'] - 1 >
                this.status.slide.current
                    ? this.status.slide.current + 1
                    : 0

            if (
                this.status.slide.current ==
                this.status.slide.prevCurrent
            )
                return


            this.$sliderList[this.status.slide.current].classList.add("is-current")
            this.$sliderList[this.status.slide.prevCurrent].classList.remove("is-current")
            this.status.slide.prevCurrent = this.status.slide.current

            this.next();

        })
        this.$slider.querySelector(".slider-btn .arrow-left").addEventListener('click', e => {
            this.status.slide.current =
                0 < this.status.slide.current
                    ? this.status.slide.current - 1
                    : this.$sliderList['length'] - 1

            if (
                this.status.slide.current ==
                this.status.slide.prevCurrent
            )
                return
            this.status.slide.prevCurrent = this.status.slide.current
            this.prev();
        })


        // this.effect.svg(document.querySelectorAll('.js__svg'), 'set')
        // this.effect.show(document.querySelectorAll('.js__show'), 'set')
    }
    next(){

        this.status.slide.slideTime = 0;
        this.status.slide.motion = true;

        this._sliderNumUpdate()

        for (let i in this.$sliderList) {
            if (this.$sliderList[i].nodeType != 1) break
            if( i == this.status.slide.current ){
                TweenMax.fromTo(
                    this.$sliderList[i],
                    1.2,
                    {
                        scale: 1.04
                    },{
                        delay:0.1,
                        opacity:1,
                        scale : 1,
                        ease: Power2.easeOut,
                        onComplete: () => {
                            this.status.slide.motion = false;
                        }
                    },
                )
                TweenMax.fromTo(
                    this.$sliderListSide[i],
                    1.2,
                    {
                        scale: 1.04
                    },{
                        opacity:1,
                        scale : 1,
                        ease: Power2.easeOut,
                    },
                )
            }else{
                TweenMax.to(
                    this.$sliderList[i],
                    1.2,
                    {
                        delay:0.1,
                        opacity:0,
                        scale : 1.04,
                        ease: Power2.easeOut
                    },
                )
                TweenMax.to(
                    this.$sliderListSide[i],
                    1.2,
                    {
                        opacity:0,
                        scale : 1.04,
                        ease: Power2.easeOut
                    },
                )
            }
        }
    }
    prev(){

        this.status.slide.slideTime = 0;
        this.status.slide.motion = true;

        this._sliderNumUpdate()

        TweenMax.to(
            [this.$sliderList,this.$sliderListSide],
            1.2,
            {
                opacity:0,
                scale : 1.1,
                ease: Power2.easeOut,
            },
        )
        TweenMax.to(
            [this.$sliderList[this.status.slide.current],this.$sliderListSide[this.status.slide.current]],
            1.2,
            {
                opacity:1,
                scale : 1,
                ease: Power2.easeOut,
                onComplete: () => {
                    this.status.slide.motion = false;
                }
            },
        )
    }
    render(){

        if(this.status.slide.motion) return;

        this.status.slide.slideTime = Number(this.status.slide.slideTime) + 1;
        if(this.status.slide.slideTime == 280){
            if(this.status.slide.current == this.status.slide.max){
                this.status.slide.current = 0;
            }else{
                this.status.slide.current = Number(this.status.slide.current) + 1;
            }
            this.next()
        }
    }
    resize(w, h, deviceSize) {}
    _sliderNumUpdate() {
        TweenMax.to(this.$sliderNum, 0.4, {
            y: -110 + '%',
            ease: Power2.easeOut,
            onComplete: () => {
                TweenMax.set(this.$sliderNum, { y: 110 + '%' })

                this.$sliderNum.textContent =
                    '0' + (this.status.slide.current + 1)

                TweenMax.to(this.$sliderNum, 0.4, {
                    y: 0 + '%',
                    ease: Power2.easeOut,
                })
            },
        })
    }
}